import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isTokenValid } from '../utils/auth';
import { generarCotratoPDFCumple } from '../utils/generadorContratoPDFCumple';

const Header = () => {
    const navigate = useNavigate();
    const loggedIn = isTokenValid(localStorage.getItem('jwt'));

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        window.dispatchEvent(new Event('authChange'));
    };

    const handlePerfil = () => {
        navigate('/mis-datos');
    };

    const handleDescargarContrato = () => {
        generarCotratoPDFCumple();
    };

    return (
        <header className="flex items-center justify-between px-6 py-3 bg-white border-b border-gray-200">
            <h1 className="text-xl font-semibold text-gray-900 m-0">MJ Jump</h1>
            <div className="flex items-center gap-3">
                {loggedIn && (
                    <button
                        onClick={handleDescargarContrato}
                        className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors"
                    >
                        Descargar contrato
                    </button>
                )}
                <button
                    onClick={handlePerfil}
                    className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
                >
                    Mi perfil
                </button>
                <button
                    onClick={handleLogout}
                    className="px-4 py-2 text-sm font-medium text-white bg-danger-600 rounded-md hover:bg-danger-700 transition-colors"
                >
                    Cerrar sesión
                </button>
            </div>
        </header>
    );
};

export default Header;
